import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Consultation", path: "/consultation" },
  { label: "Ministry", path: "/ministry" },
  { label: "Store", path: "/store" },
  { label: "Contact", path: "/contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" className="flex flex-col leading-tight">
          <span
            className={`font-bold text-xl tracking-tight transition-colors duration-300 ${
              scrolled ? "text-stone-800" : "text-white"
            }`}
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Dr. Sheldon Mckenzie
          </span>
          <span
            className={`text-xs tracking-widest uppercase transition-colors duration-300 ${
              scrolled ? "text-amber-700" : "text-amber-300"
            }`}
          >
            Endocrinologist &amp; Pastor
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium tracking-wide transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === link.path
                  ? scrolled
                    ? "text-amber-700"
                    : "text-amber-300"
                  : scrolled
                  ? "text-stone-600 hover:text-amber-700"
                  : "text-white/90 hover:text-white"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/consultation"
            className="ml-2 px-5 py-2 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer transition-all duration-200 bg-amber-700 text-white hover:bg-amber-800"
          >
            Book Now
          </Link>
        </nav>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden flex flex-col gap-1.5 cursor-pointer p-2"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span
            className={`block w-6 h-0.5 transition-all duration-300 ${
              scrolled ? "bg-stone-800" : "bg-white"
            } ${menuOpen ? "rotate-45 translate-y-2" : ""}`}
          />
          <span
            className={`block w-6 h-0.5 transition-all duration-300 ${
              scrolled ? "bg-stone-800" : "bg-white"
            } ${menuOpen ? "opacity-0" : ""}`}
          />
          <span
            className={`block w-6 h-0.5 transition-all duration-300 ${
              scrolled ? "bg-stone-800" : "bg-white"
            } ${menuOpen ? "-rotate-45 -translate-y-2" : ""}`}
          />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-stone-100 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium cursor-pointer ${
                location.pathname === link.path
                  ? "text-amber-700"
                  : "text-stone-600 hover:text-amber-700"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/consultation"
            className="mt-2 px-5 py-2 rounded-full text-sm font-semibold text-center whitespace-nowrap cursor-pointer bg-amber-700 text-white hover:bg-amber-800"
          >
            Book Now
          </Link>
        </div>
      )}
    </header>
  );
}
